import React from "react";
import { GoArrowLeft } from "react-icons/go";
import { useNavigate } from "react-router-dom";

const PatientSaleHistory = () => {
  const navigate = useNavigate();

  // Static data for main branch
  const name = "Jane";
  const gender = "Female";
  const age = 22;
  const contact = "645357589";
  const address = "Vizag";
  const firstSale = "2025-08-15";

  // Show only "THIS BRANCH"
  const branch = {
    key: "this",
    label: "THIS BRANCH",
    city: "Visakhapatnam",
    name: "Medplus",
    salesHistory: [
      {
        date: "2025-08-15",
        invoice: "Invoice/1",
        amount: 322,
        productCount: 1,
        products: [
          {
            name: "Ibuprofen 500 mg",
            quantity: 2,
            mrp: 182.81,
            rate: 160.87,
            discountPercent: 12,
          },
        ],
      },
      {
        date: "2025-09-10",
        invoice: "Invoice/2",
        amount: 548,
        productCount: 2,
        products: [
          {
            name: "Paracetamol 500 mg",
            quantity: 3,
            mrp: 95.50,
            rate: 85.60,
            discountPercent: 10,
          },
          {
            name: "Cetirizine 10 mg",
            quantity: 1,
            mrp: 70.00,
            rate: 63.00,
            discountPercent: 10,
          },
        ],
      },
    ],
    followUps: [{ date: "2025-10-15" }],
    stockInfo: {
      lastBought: { units: 2, date: "2025-10-15" },
      nextRefill: { units: 2, date: "2025-10-14" },
      brandName: "Ibuprofen 500 mg",
      unitsLeft: 0,
      unitsLeftDate: "2025-08-14",
    },
  };

  return (
    <div className="psh-root">
      <style>
        {`
        /* All your CSS as before (can be copy-pasted directly) */
        .psh-root {
          min-height: 100vh;
          width: 100%;
          margin: 0;
          padding: 0;
        }
        .psh-container {
          max-width: 100%;
          margin: 0 auto;
          padding: 32px 16px;
          background: #fff;
          border-radius: 14px;
          box-shadow: 0 6px 32px 0 rgba(0,0,0,.1);
          min-height: calc(100vh - 64px);
        }
        .psh-header {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 32px;
          gap: 24px;
        }
        .psh-avatar {
          width: 64px;
          height: 64px;
          border-radius: 14px;
          background: #c9d5fa;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 2rem;
          color: #364ad2;
        }
        .psh-h2 {
          font-weight: bold;
          font-size: 1.2rem;
          color: #203342;
          margin-bottom: 3px;
          letter-spacing: .5px;
        }
        .psh-header-info {
          min-width: 230px;
        }
        .psh-header-row {
          font-size: 1rem;
          color: #7c8294;
          line-height: 1.4;
        }
        .psh-btn {
          margin-left: auto;
          background: #364ad2;
          color: #fff;
          border: none;
          font-size: 1rem;
          border-radius: 0.5rem;
          padding: 0.65rem 1.5rem;
          cursor: pointer;
          font-weight: 600;
          transition: background 0.18s;
        }
        .psh-btn:hover { background: #203342; }
        .psh-table-wrap {
          overflow-x: auto;
        }
        .psh-table {
          border-collapse: collapse;
          width: 100%;
        }
        .psh-table th, .psh-table td {
          padding: 12px 16px;
          text-align: left;
        }
        .psh-table th {
          color: #8798ad;
          border-bottom: 1px solid #e5eaf1;
          font-weight: 700;
          font-size: 1rem;
        }
        .psh-table tbody tr { background: #fff; }
        .psh-table tbody tr:hover {
          background: #e6f7fc;
          transition: background 0.18s;
        }
        .psh-table td {
          border-bottom: 1px solid #e5eaf1;
          font-size: 1rem;
          color: #3a4653;
        }
        .psh-section-title {
          font-weight: 700;
          color: #444d56;
          font-size: 1.08rem;
          margin-bottom: 0.4rem;
        }
        .psh-follow {
          background: #e8faea;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px;
          margin-bottom: 28px;
          color: #1dd075;
          font-size: 1rem;
        }
        .psh-follow label { font-weight: 500; }
        .psh-follow button {
          background: #bff7cb;
          color: #046c36;
          border: none;
          outline: none;
          padding: 8px 16px;
          font-weight: 600;
          border-radius: 22px;
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 1rem;
          cursor: pointer;
        }
        .psh-stock {
          border: 1.2px solid #e6edf5;
          background: #f5fcff;
          border-radius: 12px;
          padding: 20px;
          color: #25304b;
          margin-top: 12px;
          font-size: 1rem;
        }
        .psh-stock-row {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          gap: 2.5rem;
          margin-bottom: 1rem;
        }
        .psh-stock-title {
          font-weight: 600;
          color: #7b899c;
          text-transform: uppercase;
          margin-bottom: 3px;
          font-size: .96rem;
        }
        .psh-stock-value {
          font-weight: 700;
          color: #25304b;
        }
        .psh-stock-value.red {
          color: #d42222;
        }
        @media (max-width: 700px) {
          .psh-container { padding: 10px; }
          .psh-header { gap: 1rem; }
          .psh-h2 { font-size: 1.15rem; }
          .psh-table th, .psh-table td { padding: 8px 6px; }
          .psh-stock-row { gap: 1.2rem; }
        }
        `}
      </style>

      <button
        className="mb-2 bg-[#fff] inline-flex items-center justify-center shrink-0 gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground size-10"
        onClick={() => navigate(-1)}
      >
        <GoArrowLeft />
        <span className="sr-only">Back</span>
      </button>

      <div className="psh-container">
        {/* Header */}
        <div className="psh-header">
          <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
            <div className="psh-avatar">
              {name
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase())
                .join("")}
            </div>
            <div className="psh-header-info">
              <div className="psh-h2">{name.toUpperCase()}</div>
              <div className="psh-header-row">
                {gender} {age ? `(${age}Y)` : ""}
              </div>
              <div className="psh-header-row">
                <b>First Sale:</b> {new Date(firstSale).toLocaleDateString()}
              </div>
              <div className="psh-header-row">
                <b>Contact:</b> {contact}
              </div>
              <div className="psh-header-row">
                <b>Address:</b> {address}
              </div>
            </div>
          </div>
        </div>

        {/* Main Content for the branch */}
        {branch.salesHistory.length === 0 ? (
          <div style={{
            padding: "56px 0",
            textAlign: "center",
            color: "#aeb8c4",
            fontSize: "1.15rem"
          }}>
            No sale history for this branch.
          </div>
        ) : (
          <>
            <div className="psh-table-wrap" style={{ marginBottom: "32px" }}>
              <table className="psh-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Invoice</th>
                    <th>Amount</th>
                    <th className="text-right">Products</th>
                  </tr>
                </thead>
                <tbody>
                  {branch.salesHistory.map((sale, i) => (
                    <tr key={i}>
                      <td>{new Date(sale.date).toLocaleDateString()}</td>
                      <td>{sale.invoice}</td>
                      <td>₹{sale.amount}</td>
                      <td style={{ color: "#269866", fontWeight: 600 }}>
                        {sale.productCount} product{sale.productCount > 1 ? "s" : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Product List */}
            <div style={{ marginBottom: "30px" }}>
              <div className="psh-section-title">Product</div>
              <table className="psh-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th style={{ textAlign: "center" }}>Qty</th>
                    <th style={{ textAlign: "right" }}>MRP</th>
                    <th style={{ textAlign: "right" }}>Rate</th>
                    <th style={{ textAlign: "right" }}>Disc%</th>
                  </tr>
                </thead>
                <tbody>
                  {branch.salesHistory.flatMap((sale) =>
                    sale.products.map((p, idx) => (
                      <tr key={sale.invoice + idx}>
                        <td>{p.name}</td>
                        <td style={{ textAlign: "center" }}>{p.quantity}</td>
                        <td style={{ textAlign: "right" }}>₹{p.mrp.toFixed(2)}</td>
                        <td style={{ textAlign: "right" }}>₹{p.rate.toFixed(2)}</td>
                        <td style={{ textAlign: "right" }}>{p.discountPercent}%</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Stock and Brand Info */}
            <div className="psh-stock">
              <div className="psh-section-title" style={{ marginBottom: 10 }}>
                {branch.name}, {branch.city}
              </div>
              <div className="psh-stock-row">
                <div>
                  <div className="psh-stock-title">Last Bought</div>
                  <div className="psh-stock-value">
                    {branch.stockInfo.lastBought.units} units
                  </div>
                  <div style={{ fontSize: '.93em', color: "#8096be" }}>
                    on {new Date(branch.stockInfo.lastBought.date).toLocaleDateString()}
                  </div>
                </div>
                <div>
                  <div className="psh-stock-title">Next Refill*</div>
                  <div className="psh-stock-value">
                    {branch.stockInfo.nextRefill.units} units
                  </div>
                  <div style={{ fontSize: '.93em', color: "#8096be" }}>
                    on {new Date(branch.stockInfo.nextRefill.date).toLocaleDateString()}
                  </div>
                </div>
                <div>
                  <div className="psh-stock-title">Brand(s)</div>
                  <div className="psh-stock-value" style={{ color: "#23bb8b" }}>
                    {branch.stockInfo.brandName}
                  </div>
                  <a href="#stock" style={{ fontSize: ".95em", color: "#1dd075" }}>
                    Check Current Stock
                  </a>
                </div>
                <div>
                  <div className="psh-stock-title">Units Left*</div>
                  <div className={`psh-stock-value${branch.stockInfo.unitsLeft === 0 ? " red" : ""}`}>
                    {branch.stockInfo.unitsLeft} units
                  </div>
                  <div style={{ fontSize: '.93em', color: "#8096be" }}>
                    over by {new Date(branch.stockInfo.unitsLeftDate).toLocaleDateString()}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PatientSaleHistory;
